import ISvgProps from '../../../SvgLoader/ISvgProps';

export const NotAcceptCheck = (props: ISvgProps) => {
	return (
		<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
			<mask id="path-1-inside-1_1193_459" fill="white">
				<rect x="2" y="12" width="49" height="29" rx="1" />
			</mask>
			<rect
				x="2"
				y="12"
				width="49"
				height="29"
				rx="1"
				stroke={props.primaryColor}
				strokeWidth="3"
				mask="url(#path-1-inside-1_1193_459)"
			/>
			<path
				d="M44.1206 19H7.4929C7.25974 19 7.03613 19.0913 6.87126 19.2539C6.70639 19.4165 6.61377 19.6369 6.61377 19.8668C6.61377 20.0968 6.70639 20.3172 6.87126 20.4798C7.03613 20.6424 7.25974 20.7337 7.4929 20.7337H44.1206C44.3538 20.7337 44.5774 20.6424 44.7423 20.4798C44.9071 20.3172 44.9998 20.0968 44.9998 19.8668C44.9998 19.6369 44.9071 19.4165 44.7423 19.2539C44.5774 19.0913 44.3538 19 44.1206 19Z"
				fill={props.primaryColor}
			/>
			<path
				d="M44.1209 26H7.87913C7.64597 26 7.42236 26.0913 7.25749 26.2539C7.09262 26.4165 7 26.6369 7 26.8668C7 27.0968 7.09262 27.3172 7.25749 27.4798C7.42236 27.6424 7.64597 27.7337 7.87913 27.7337H44.1209C44.354 27.7337 44.5776 27.6424 44.7425 27.4798C44.9074 27.3172 45 27.0968 45 26.8668C45 26.6369 44.9074 26.4165 44.7425 26.2539C44.5776 26.0913 44.354 26 44.1209 26Z"
				fill={props.primaryColor}
			/>
			<circle cx="47.5623" cy="36.6213" r="7.05862" fill="#F5F5F5" />
			<path
				d="M48.555 46.11C43.8301 46.11 40 42.2799 40 37.555C40 32.8301 43.8301 29 48.555 29C53.2799 29 57.11 32.8301 57.11 37.555C57.11 42.2799 53.2799 46.11 48.555 46.11ZM48.555 36.3453L46.1356 33.9251L44.9251 35.1356L47.3453 37.555L44.9251 39.9744L46.1356 41.1849L48.555 38.7647L50.9744 41.1849L52.1849 39.9744L49.7647 37.555L52.1849 35.1356L50.9744 33.9251L48.555 36.3453Z"
				fill="#FE5555"
			/>
		</svg>
	);
};
